import { format, parseISO } from "date-fns";
import { tr } from "date-fns/locale";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { SERVICE_LABEL, waLink } from "@/lib/site";

const PACKAGE_INFO = {
  "enduro-tur": "Enduro Tur Paketi — 5.000 TL (2 saat; motor, ekipman ve kıyafet dahil)",
  "cocuk-egitim": "Çocuk Eğitim Paketi — 5 ders, toplam 25.000 TL",
};

const dateTr = (d) => format(parseISO(d), "d MMMM yyyy, EEEE", { locale: tr });

export const bookingWhatsApp = (b) => waLink([
  "Merhaba FX Motor Sporları, rezervasyon talebim:",
  `Hizmet: ${SERVICE_LABEL[b.service]}`,
  PACKAGE_INFO[b.service] && `Paket: ${PACKAGE_INFO[b.service]}`,
  `Tarih: ${dateTr(b.date)}`,
  `Kişi sayısı: ${b.people}`,
  `Ad Soyad: ${b.name}`,
  `Telefon: ${b.phone}`,
  b.note && `Not: ${b.note}`,
].filter(Boolean).join("\n"));

export const BookingSuccess = ({ booking, onReset }) => {
  const dateText = dateTr(booking.date);
  return (
    <div data-testid="booking-success" className="border border-white/15 bg-black p-8">
      <CheckCircle2 className="h-12 w-12 text-brand" strokeWidth={1.5} />
      <h3 className="mt-6 font-display text-4xl uppercase leading-none text-white">Talebin alındı, {booking.name.split(" ")[0]}!</h3>
      <p className="mt-4 text-neutral-400">
        <span className="text-white">{SERVICE_LABEL[booking.service]}</span> · {dateText} · {booking.people} kişi
      </p>
      <p className="mt-4 text-neutral-400">WhatsApp'a yönlendiriliyorsun; açılan mesajı gönder, ekibimiz en kısa sürede dönüş yapsın. Açılmadıysa aşağıdaki butona dokun.</p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <a href={bookingWhatsApp(booking)} target="_blank" rel="noopener noreferrer" data-testid="booking-success-whatsapp-btn" className="flex items-center justify-center gap-3 bg-[#25D366] px-6 py-4 font-bold uppercase tracking-wider text-black transition-colors hover:bg-white">
          <MessageCircle className="h-5 w-5" /> WhatsApp'tan onayla
        </a>
        <button onClick={onReset} data-testid="booking-new-btn" className="border border-white/20 px-6 py-4 font-semibold uppercase tracking-wider text-white transition-colors hover:border-white">Yeni talep</button>
      </div>
    </div>
  );
};
